import MetricBox from "../components/UI/MetricBox";
import { Skeleton, theme } from "antd";

const MetricBoxLoader = () => {
  const { token } = theme.useToken();
  return (
    <div
      className="soft-shadow"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        minWidth: "11.5vw",
        minHeight: "148px",
        backgroundColor: "var(--tertiary-color)",
        borderRadius: token.cardRadius,
      }}
    >
      <Skeleton
        title={false}
        paragraph={{
          rows: 3,
          width: ["90%", "90%", "90%"],
          style: {
            marginLeft: "10%",
            marginTop: "5%",
          },
        }}
        active
      />
    </div>
  );
};

export default function BoxMetricContainer({
  useApi,
  apiParams,
  boxMetricType,
  includeTooltip = false,
}) {
  const api = useApi(apiParams);

  if (!api.data) {
    return <MetricBoxLoader />;
  }

  // Safely access the title with optional chaining
  const title = api.data?.title || "No Title";

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          width: "100%",
          // height: "100%",
          // minHeight: "12px",
          alignItems: "center",
        }}
      >
        {!api.isFetching ? (
          <MetricBox
            title={title}
            popValue={api.data.pop}
            value={api.data.value}
            includeTooltip={includeTooltip}
            isInverted={api.data.is_inverted}
            popNonPercentValue={api.data.pop_value}
            boxMetricType={boxMetricType}
          />
        ) : (
          <MetricBoxLoader />
        )}
      </div>
    </>
  );
}
